import styled from 'styled-components';
import { DropdownToggle, InputGroup, Input } from 'reactstrap';

const CountrySelectDropdown = styled(DropdownToggle)`
  box-shadow: none;
  font-weight: 400;
  border: none;
  height: 100%;

  color: #8898aa;
  border: none;
  padding: 12px 0 12px 12px;
  &:hover {
    background-color: #fff;
    box-shadow: none;
    color: #8898aa !important;
  }
  &:focus {
    background-color: #fff;
    box-shadow: none;
    color: #8898aa;
  }
  &:active {
    background-color: #fff !important;
    box-shadow: none !important;
  }

  &[disabled],
  &[aria-disabled='true'] {
    background-color: #dee2e6 !important;
    color: #8898aa !important;
    box-shadow: none !important;
    cursor: not-allowed;
  }
`;

const NumberInput = styled(Input)`
  border: none;
  padding-left: 6px;
`;

const PhoneInputGroup = styled(InputGroup)`
  border: 1px solid #dee2e6;
`;

const ActionInputButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 52px;
  height: 46px;
  background-color: ${(props) => props.primaryColor || '#fff'};
  color: #fff;
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

  &:hover {
    box-shadow: 0px 0px 6px 0px rgba(172, 182, 201, 1);
  }
`;

const ActionsPhoneGroup = styled.div`
  display: flex;
  gap: 0.3rem;
  margin-left: 0.5rem;
  align-items: center;
  justify-content: center;
`;

export {
  CountrySelectDropdown,
  PhoneInputGroup,
  NumberInput,
  ActionInputButton,
  ActionsPhoneGroup
};
